import {Component, ElementRef, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {NestedTreeControl} from "@angular/cdk/tree";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {TreeNode, TreeSelect} from "../tree-select/tree-select";
import {first} from "rxjs";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {OrganizationService} from "../../services/organization.service";
import {ProdDialogService, ProdDialogType, ProdDialogData} from 'prod-dialog';
import {CompanyFormComponent} from "./company-form/company-form.component";
import {FormEvent} from 'prod-grid';
import {DistributorFormComponent} from "./distributor-form/distributor-form.component";
import {OrganizationTypeName} from "../../enum/organization-type";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss']
})
export class OrganizationsComponent implements OnInit {
  @ViewChild('treeWrapper') treeElement: ElementRef;
  @ViewChild('treeInput') treeInput: ElementRef;

  title = this.translate.instant('organizations.title');
  treeControl = new NestedTreeControl<TreeNode>(node => node.children);
  treeDataSource = new MatTreeNestedDataSource<TreeNode>();
  filteredDataSource = new MatTreeNestedDataSource<TreeNode>()
  mainFilterValue: string = '';
  secondaryFilterValue: string = '';
  formResponseEvent: EventEmitter<FormEvent> = new EventEmitter<FormEvent>();

  constructor(private organizationTreeSelect: OrganizationTreeSelect,
              private organizationService: OrganizationService,
              private dialogService: ProdDialogService,
              private translate: TranslateService) { }

  ngOnInit(): void {
    this.getData();
    this.formResponseEvent.subscribe(event => {
      this.organizationTreeSelect.organizationTreeUpdate$.emit();
      this.getData()
    });
  }

  getData() {
    this.organizationService.getTreeData(true).pipe(first()).subscribe(
      data => {
        this.treeDataSource.data = this.filteredDataSource.data = data;
        this.treeControl.dataNodes = this.treeDataSource.data;
        this.treeControl.expandAll();
      });
  }

  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;

  onChangeFilter() {
    const value1 = typeof this.mainFilterValue === 'string' ? this.mainFilterValue.toLowerCase().trim() : '';
    const value2 = typeof this.secondaryFilterValue === 'string' ? this.secondaryFilterValue.toLowerCase().trim() : '';
    this.filteredDataSource.data = this.filterTree(this.filterTree(this.treeDataSource.data, value1, true), value2);
    this.treeControl.dataNodes = this.filteredDataSource.data;
    this.treeControl.expandAll();
  }

  filterTree(array, text, startsWith: boolean = false) {
    const getNodes = (result, object) => {
      if (startsWith ? object.name.toLowerCase().startsWith(text) : object.name.toLowerCase().includes(text)) {
        result.push(object);
        return result;
      }
      if (Array.isArray(object.children)) {
        const children = object.children.reduce(getNodes, []);
        if (children.length) result.push({...object, children});
      }
      return result;
    };
    return array.reduce(getNodes, []);
  }

  findNodeById(array, id) {
    if (!array) return null;
    let stack = [...array], node, i;

    while (stack.length > 0) {
      node = stack.pop();
      if (node.id === id) {
        return node;
      } else if (node.children && node.children.length) {
        for (i = 0; i < node.children.length; i += 1) {
          stack.push(node.children[i]);
        }
      }
    }
    return null;
  }

  onSelectNode(node) {
    this.organizationTreeSelect.organizationTreeSelect$.next(node.id);
  }

  getIcon(node) {
    if (node.organizationType) {
      if (node.organizationType.name === OrganizationTypeName.DISTRIBUTOR) return 'business_center';
      if (node.organizationType.name === OrganizationTypeName.COMPANY) return 'other_houses';
      if (node.organizationType.name === OrganizationTypeName.SITE) return 'house';
    }
    return 'folder';
  }

  addNewCompany() {
    this.dialogService.open(new ProdDialogData({
      component: CompanyFormComponent,
      type: ProdDialogType.FORM,
      data: {
        formResponseEvent: this.formResponseEvent
      },
    }))
  }

  addNewDistributor() {
    this.dialogService.open(new ProdDialogData({
      component: DistributorFormComponent,
      type: ProdDialogType.FORM,
      data: {
        formResponseEvent: this.formResponseEvent
      },
    }))
  }

  clearFilters() {
    this.mainFilterValue = this.secondaryFilterValue = '';
    this.onChangeFilter();
  }
}
